// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dop-panel {
  border: 1px solid #d1d5db;
  border-radius: 12px;
  background: #ffffff;
  padding: 10px;
}

.dop-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 10px;
}

.dop-title {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: #111827;
}

.dop-collapse-btn {
  min-width: 30px;
  height: 30px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #f8fafc;
  color: #111827;
  cursor: pointer;
}

.dop-collapse-btn--collapsed {
  width: 100%;
  height: auto;
  padding: 10px 12px;
  font-weight: 700;
  font-size: 14px;
  color: #111827;
  background: #ffffff;
  text-align: center;
}

.dop-collapsed-wrap {
  width: 100%;
}

.dop-group {
  margin-bottom: 10px;
}

.dop-group-title {
  font-size: 12px;
  font-weight: 700;
  color: #475569;
  margin-bottom: 6px;
}

.dop-buttons {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
}

.dop-btn {
  padding: 8px 10px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #ffffff;
  color: #111827;
  cursor: pointer;
  font-size: 12px;
}

.dop-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.dop-btn--danger {
  background: #dc2626;
  border-color: #dc2626;
  color: #ffffff;
}

.dop-status {
  color: #6b7280;
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/components/designer/page/DesignerOrderPanel.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB","sourcesContent":[".dop-panel {\n  border: 1px solid #d1d5db;\n  border-radius: 12px;\n  background: #ffffff;\n  padding: 10px;\n}\n\n.dop-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.dop-title {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.dop-collapse-btn {\n  min-width: 30px;\n  height: 30px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #f8fafc;\n  color: #111827;\n  cursor: pointer;\n}\n\n.dop-collapse-btn--collapsed {\n  width: 100%;\n  height: auto;\n  padding: 10px 12px;\n  font-weight: 700;\n  font-size: 14px;\n  color: #111827;\n  background: #ffffff;\n  text-align: center;\n}\n\n.dop-collapsed-wrap {\n  width: 100%;\n}\n\n.dop-group {\n  margin-bottom: 10px;\n}\n\n.dop-group-title {\n  font-size: 12px;\n  font-weight: 700;\n  color: #475569;\n  margin-bottom: 6px;\n}\n\n.dop-buttons {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 6px;\n}\n\n.dop-btn {\n  padding: 8px 10px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #111827;\n  cursor: pointer;\n  font-size: 12px;\n}\n\n.dop-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.dop-btn--danger {\n  background: #dc2626;\n  border-color: #dc2626;\n  color: #ffffff;\n}\n\n.dop-status {\n  color: #6b7280;\n  font-size: 12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
